// src/context/SubjectContext.js
import { createContext, useContext } from 'react'
import { useSubjects } from '../hooks/useSubjects'

const SubjectContext = createContext(null)

export function SubjectProvider({ children }) {
  const value = useSubjects()
  return <SubjectContext.Provider value={value}>{children}</SubjectContext.Provider>
}

export const useSubject = () => useContext(SubjectContext)